import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUser, setReturnURL, isUserMobileMissing } from '../../../utils/commonfunction';
import { ROLE } from "../../../utils/Constants";

const UserPrivateRoute = ({ component: Component }) => {
    const userData = getUser(ROLE.USER);
    const location = useLocation();

    return (
        <>
            {(function(){
                if(Object.keys(userData).length && userData.token){
                    if (location.pathname !== "/user/profile-edit" && isUserMobileMissing(userData)) {
                        return <Navigate to="/user/profile-edit" replace />;
                    }
                    return <Component/>
                }else{
                    setReturnURL(ROLE.USER);
                    return <Navigate to="/user/login" />;
                }
            })()}
        </>
    )
}

export default UserPrivateRoute;